var url = "19d6a43ba4795bee4a42e1fd5831f18b.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;